<!-- ============================================================== -->
<!-- toggle and nav items -->
<!-- ============================================================== -->
<ul class="navbar-nav float-left mr-auto">
    <!-- ============================================================== -->
    <!-- Search -->
    <!-- ============================================================== -->
</ul>
<!-- ============================================================== -->
<!-- Right side toggle and nav items -->
<!-- ============================================================== -->
<ul class="navbar-nav float-right">
<!--    <li class="nav-item m-r-20">-->
<!--        <a href="https://wrappixel.com/templates/niceadmin-angular/" class="btn btn-block btn-danger">Logout</a>-->
<!--    </li>-->
</ul>
